export default __webpack_public_path__ + "static/media/st3.aec89c68.jpg";